module.exports = __webpack_public_path__ + "static/img/braindr_xgboost_agg1.861c76c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/braindr_xgboost_agg1.png
// module id = n1sS
// module chunks = 1